import MainTitle from "../Components/MainTitle/MainTtitle";

function Contact() {
  const titleRows = ["Let's work together.", "Get in touch."];

  window.scrollTo(0, 0);

  return <MainTitle titleRows={titleRows} />;
}

export default Contact;
